import styled, { ThemeProvider } from "styled-components";
import { lightTheme } from "./utils/Themes";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import { useState } from "react";
import Authentication from "./pages/Authentication";
import ShopListing from "./pages/ShopListing";
import Favourite from "./pages/Favourite";
import NewArrival from "./pages/NewArrival"
import Cart from "./pages/Cart";
import ProductDetails from "./pages/ProductDetails";
import Contact from "./pages/Contact"
import { useSelector } from "react-redux";
import ToastMessage from "./components/ToastMessage";
import Footer from "./components/Footer";

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.bg};
  color: ${({ theme }) => theme.text_primary};
  overflow-x: hidden;
  overflow-y: auto;
  transition: all 0.2s ease;
`;

function App() {
  const { currentUser } = useSelector((state) => state.user);
  const { open, message, severity } = useSelector((state) => state.snackbar);
  const [openAuth, setOpenAuth] = useState(false);
  return (
    <ThemeProvider theme={lightTheme}>
      <BrowserRouter>
        <Container>
          <Navbar setOpenAuth={setOpenAuth} currentUser={currentUser} />
          <Routes>
            <Route path="/" exact element={<Home setOpenAuth={setOpenAuth} />} />
            <Route path="/shop" exact element={<ShopListing setOpenAuth={setOpenAuth} />} />
            <Route path="/favorite" exact element={<Favourite  setOpenAuth={setOpenAuth}/>} />
            <Route path="/cart" exact element={<Cart setOpenAuth={setOpenAuth}/>} />
            <Route path="/shop/:id" exact element={<ProductDetails setOpenAuth={setOpenAuth} />} />
            <Route path="/NewArrival" exact element={<NewArrival setOpenAuth={setOpenAuth}/>} />
            <Route path="/Order" exact element={<Cart />} />
            <Route path="/Contact" exact element={<Contact />} />
          </Routes>
          {openAuth && (
            <Authentication openAuth={openAuth} setOpenAuth={setOpenAuth} />
          )}
          {open && (
            <ToastMessage open={open} message={message} severity={severity} />
          )}
          <Footer />
        </Container>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
